// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__G7pLQ","large":"styles_large__1i0-S"};